var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwapup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "black",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 28,
    height: 28,
    rx: 14,
    stroke: "white",
    strokeOpacity: 0.16,
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8243 17.8611C22.0586 18.0759 22.0586 18.4241 21.8243 18.6389L19.4243 20.8389C19.1899 21.0537 18.81 21.0537 18.5757 20.8389L16.1757 18.6389C15.9414 18.4241 15.9414 18.0759 16.1757 17.8611C16.4101 17.6463 16.7899 17.6463 17.0243 17.8611L18.4 19.1222L18.4 13.85C18.4 13.5462 18.6686 13.3 19 13.3C19.3314 13.3 19.6 13.5462 19.6 13.85L19.6 19.1222L20.9757 17.8611C21.2101 17.6463 21.5899 17.6463 21.8243 17.8611ZM15.8243 13.1389C15.5899 13.3537 15.2101 13.3537 14.9757 13.1389L13.6 11.8778L13.6 17.15C13.6 17.4538 13.3314 17.7 13 17.7C12.6686 17.7 12.4 17.4538 12.4 17.15L12.4 11.8778L11.0243 13.1389C10.7899 13.3537 10.4101 13.3537 10.1757 13.1389C9.94142 12.9241 9.94142 12.5759 10.1757 12.3611L12.5757 10.1611C12.8101 9.9463 13.1899 9.9463 13.4243 10.1611L15.8243 12.3611C16.0586 12.5759 16.0586 12.9241 15.8243 13.1389Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapup);
export default __webpack_public_path__ + "static/media/swapup.3908437a.svg";
export { ForwardRef as ReactComponent };